$(document).ready(function () {

    let cardsComponentSliderOptions = {
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 2,
        dots: false,
        responsive: [
            {
                breakpoint: 1367,
                settings: {}
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                }
            },{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    };

    $(".js-slider-cards-component").each(function () {
        let $slider = $(this);
        if ($(this).hasClass("inizialized")){
            return;
        }

        if ($(window).width() < 576){
            return;
        }

        if ($(this).find(".slider-cards-component__slide").length > 3) {
            if($(this).hasClass("center-mode")){
                // no arrows, previous and next item partially show
                //invisible arrow, clicking on the element that is partially show uses the arrows
                cardsComponentSliderOptions.centerMode = true;
                cardsComponentSliderOptions.variableWidth = false;

                $.each(cardsComponentSliderOptions.responsive, function(index, value) {
                    if (value.breakpoint === 1200) {
                        value.settings.variableWidth = true;
                    }
                });

                $(this).parent().removeClass("container container-sm-0").addClass("container-fluid")
            }

            //filtro lo slider sulla base del contenuto della variabile window.userVisibility (impostata da react)
            $slider.on('init', function (event, slick) {
                setTimeout(() => {
                    filterSliderBasedOnGlobalVariable();
                },10)
            });

            $(this).slick(cardsComponentSliderOptions);
            $(this).addClass("inizialized");
        }else{
            if($(this).hasClass("center-mode")){
                $(this).parent().removeClass("container container-sm-0").addClass("container-fluid")
                $(this).addClass("paddingSquareNoCarousel")
            }
        }
    });

    $(".js-slider-tpl_icons").each(function () {
        if ($(this).hasClass("inizialized") || $(window).width() > 768) return;
        if ($(this).find(".slider-cards-component__slide")) {
            $(this).slick();
            $(this).addClass("inizialized");
        }

    });

    $(".cmp_cards .listingItems").each(function () {
        let $slider = $(this);
        const isDataMobileHorizontalScroll = Boolean($(this).data("mobilehorizontalscroll"));

        if(($(window).width() < 576) && isDataMobileHorizontalScroll){
            $(this).find(".item").addClass("col-12 col-sm")
            cardsComponentSliderOptions = {
                arrows : true,
                dots : false,
                slidesToShow : 1,
                draggable : true,
                swipe : true
            }

            //filtro lo slider sulla base del contenuto della variabile window.userVisibility (impostata da react)
            $slider.on('init', function (event, slick) {
                setTimeout(() => {
                    filterSliderBasedOnGlobalVariable();
                },10)
            });

            $(this).slick(cardsComponentSliderOptions);
        }
    });

    $(".js-slider-custom-cards").each(function () {
        let $slider = $(this);
        let slickOptions = $slider.data("slick")

        if ($(this).hasClass("inizialized")) {
            return;
        }

        if ($(this).find(".slider-cards-component__slide").length > 3) {
            //filtro lo slider sulla base del contenuto della variabile window.userVisibility (impostata da react)
            $slider.on('init', function (event, slick) {
                setTimeout(() => {
                    filterSliderBasedOnGlobalVariable();
                },10)
            });
            $(this).slick(slickOptions);
            $(this).addClass("inizialized");
        }
    });

    $(".js-slider-tpl_icons").each(function () {
        if ($(this).hasClass("inizialized") || $(window).width() > 576) return;
        $(this).slick();
        $(this).addClass("inizialized");
    });

    $('.js-slide-card').slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        draggable: false,
        swipe:false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    swipe:false,
                }
            },{
                breakpoint: 992,
                settings: {
                    swipe:false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    swipe:false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    swipe:true,
                }
            }
        ]
    });
})
